import { render, staticRenderFns } from "./drill_title.vue?vue&type=template&id=96af2c66&scoped=true&"
import script from "./drill_title.vue?vue&type=script&lang=js&"
export * from "./drill_title.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/drill_title.css?vue&type=style&index=0&id=96af2c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96af2c66",
  null
  
)

export default component.exports